import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { LandingPagesService } from '../../landing-pages.service'
import { environment } from '../../../../../environments/environment'

export interface CarouselItem {
  imageUrl: string
  title: string
  description: string
  buttonText: string
}
export interface CarouselData {
  carouselItem: CarouselItem[]
  autoRotateTime: number
}

@Component({
  standalone: false,

  selector: 'vs-carousel',
  templateUrl: './bh-carousel.component.html',
  styleUrls: ['./bh-carousel.component.scss'],
})
export class BhCarouselComponent implements OnInit {
  @Input() carouselData: CarouselData
  @Output() buttonClicked = new EventEmitter()
  currentCarousel = 0
  autoRotate: any
  carouselList: CarouselItem[]

  constructor(private landingPagesService: LandingPagesService) {}

  ngOnInit(): void {
    this.currentCarousel = 0
    this.carouselList = this.carouselData.carouselItem
    this.autoRotate = setInterval(() => {
      this.changeSlide()
    }, this.carouselData.autoRotateTime * 1000)

    this.landingPagesService.preLoadImages.subscribe((data) => {
      this.carouselList = this.carouselData.carouselItem
      this.preloadImages()
    })
  }
  progressCliked(i) {
    this.currentCarousel = i
    clearInterval(this.autoRotate)
  }

  changeSlide() {
    if (this.currentCarousel == this.carouselList.length - 1) {
      this.currentCarousel = 0
    } else {
      this.currentCarousel = this.currentCarousel + 1
    }
  }

  clickButton(carousel: any) {
    this.buttonClicked.emit(carousel['urlLink'])
  }

  preloadImages() {
    this.carouselList.forEach((carousel) => {
      if (
        carousel['media'] !== undefined &&
        carousel['media']?.url !== undefined
      ) {
        new Image().src = environment.occBaseUrl + carousel['media']?.url
      }
    })
  }

  fetchImgUrl(carousel) {
    if (
      carousel['media'] !== undefined &&
      carousel['media']?.url !== undefined
    ) {
      return environment.occBaseUrl + carousel['media']?.url
    }
    return ''
  }
}
